import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { GicAnywhere } from '@atlassian/gic-anywhere';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';

import type { GicPanelBodyProps } from '../../__types__/GicPanelBody';
import { getPersistedOverrideCloudId } from '../../utils/localStorageHelpers';
import { useIssueCreateSidePanelContext } from '../../providers/IssueCreateSidePanelContextProvider';
const noop = () => {};

export const GicPanelBody = ({
	onClose,
	onSuccess,
	onFailure,
	analyticsSource,
	summary,
	descriptionAdf,
	isCreatedWithAi,
	isCreatedFromTable,
	isCreatedFromActionItems,
	issueTypeId,
	projectId,
	assigneeId,
	configuration,
	cloudId,
	additionalMappedFields,
}: GicPanelBodyProps) => {
	const { cloudId: sessionCloudId } = useSessionData();

	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [{ pageMode, hasEditPermission }] = useIssueCreateSidePanelContext();

	const persistedOverrideCloudId = getPersistedOverrideCloudId();

	const overrideCloudIdForSitePicker =
		persistedOverrideCloudId !== sessionCloudId ? persistedOverrideCloudId : undefined;

	const currentCloudId = overrideCloudIdForSitePicker || cloudId;

	useEffect(() => {
		createAnalyticsEvent({
			type: 'sendScreenEvent',
			data: {
				name: 'linkCreateScreen',
				attributes: {
					isManuallyCreated: !isCreatedWithAi,
					isCreatedWithAi,
					isCreatedFromTable,
					isCreatedFromActionItems,
					pageMode,
					hasEditPermission,
				},
				source: analyticsSource,
			},
		}).fire();
	}, [
		isCreatedWithAi,
		isCreatedFromTable,
		isCreatedFromActionItems,
		createAnalyticsEvent,
		analyticsSource,
		pageMode,
		hasEditPermission,
	]);

	return (
		<GicAnywhere
			cloudId={currentCloudId}
			consumer="confluence-highlight-issue-create"
			onInit={noop}
			onSuccess={onSuccess}
			onClose={onClose}
			onFailure={onFailure}
			summary={summary}
			descriptionAdf={descriptionAdf}
			overrideCloudId={overrideCloudIdForSitePicker}
			issueTypeId={issueTypeId}
			projectId={projectId}
			assignee={assigneeId}
			isPayloadReady
			configuration={configuration}
			additionalMappedFields={additionalMappedFields}
		/>
	);
};
